module.exports = __webpack_public_path__ + "static/media/citadele-logo.76d77fc5.svg";